module.exports = __webpack_public_path__ + "0f69b0260c877b873a51bbda5bfbc7c9.png";